/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest = {
  replicaVersionId: string;
};

/** @internal */
export const GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    replica_version_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "replica_version_id": "replicaVersionId",
    });
  });

/** @internal */
export type GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$Outbound =
  {
    replica_version_id: string;
  };

/** @internal */
export const GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest
  > = z.object({
    replicaVersionId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      replicaVersionId: "replica_version_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$Outbound;
}

export function getApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequestToJSON(
  getApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest:
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$outboundSchema
      .parse(getApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest),
  );
}

export function getApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPngRequest' from JSON`,
  );
}
